import CryptoJS from 'crypto-js'

// (function(a){
// Windows IE32
const PGEdit_IE32_EXE = 'shengpayALL.exe'
const PGEdit_IE32_VERSION = '1.0.0.1'
// Windows IE64
const PGEdit_IE64_EXE = 'shengpayALL.exe'
const PGEdit_IE64_VERSION = '1.0.0.1'
// Windows IE ClassId & ProgId
const PGEdit_IE_CLASSID = 'D3ABCF25-666E-4FE7-8ADA-D0EF754CB204'
const PGEdit_IE_ProgId = 'shengpayPassGuardX.PassGuard.1'
// Windows 非IE插件(NPAPI,用于Chrome42-,FireFox50-)
const PGEdit_FF = 'shengpayALL.exe'
const PGEdit_FF_VERSION = '1.0.0.1'
// Windows 非IE插件 Mime类型和PluginName
const PGEdit_FF_MIMETYPE = 'shengpaypass-guard-x'
const PGEdit_FF_PluginName = 'shengpayPassGuardX'
// Mac OS 插件版(NPAPI,用于Safari,FireFox50-,Chrome42-)
const PGEdit_MacOs = ''
const PGEdit_MacOs_VERSION = '1.0.0.1'
// Mac OS 插件版 Mime类型和PluginName
const PGEdit_MacOs_MIMETYPE = ''
const PGEdit_MacOs_PluginName = ''
// Windows & Mac OS 非插件(用于Chrome42+,FireFox50+,MircroSoft Edge)
const PGEdit_Edge = 'shengpayALL.exe'
const PGEdit_Edge_Mac = ''
let PGEdit_Edge_VERSION = '1.0.0.1'
const PGEdit_Edge_VERSIONMac = '1.0.0.1'

const PGEdit_LinuxamdUOSAKL = 'PG_AMD_XTZH_SXYH.deb'
const PGEdit_LinuxarmUOSAKL = 'PG_ARM_XTZH_SXYH.deb'

const PGEdit_Linuxamd = 'passguard_fjhx_1.0.0.0_amd64.deb'
const PGEdit_Linuxamd_VERSION = '1.0.0.0'
const PGEdit_Linux64 = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_Linux64_VERSION = '1.0.0.0'
const PGEdit_Linuxsw = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_Linuxsw_VERSION = '1.0.0.0'
const PGEdit_UOSamd = 'passguard_fjhx_1.0.0.0_amd64.deb'
const PGEdit_UOSamd_VERSION = '1.0.0.0'
const PGEdit_UOSarm = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_UOSarm_VERSION = '1.0.0.0'
const PGEdit_UOSmips = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_UOSmips_VERSION = '1.0.0.0'
const PGEdit_KYamd = 'passguard_fjhx_1.0.0.0_amd64.deb'
const PGEdit_KYamd_VERSION = '1.0.0.0'
const PGEdit_KYarm = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_KYarm_VERSION = '1.0.0.0'
const PGEdit_KYmips = 'passguard_fjhx_1.0.0.0_loongarch64.deb'
const PGEdit_KYmips_VERSION = '1.0.0.0'

// license授权
// 这个是正式的
// let license = 'Z2VjalJGRGdRRVdyZkJTQWVUZlc1TFRkUk1Pa3NZSEs1aVgza3M5dGw0UXN3Mkw3cVNDUXg2Qk9kSHdqKzlzTTk1NzhjcXdyaUYrOVlXWXFuMENmV2JPRmJzSmlHV2ttKzhRd1RRYmVZcWFKN21MSXpDcS8vc1JCOWNwd00wdWY3eHJxQUpkanpiOXVjdGZSemxtLzUwMTdRWEZTTHo3UFVHUEFpcUVYcUtrPXsiaWQiOjAsInR5cGUiOiJwcm9kdWN0IiwicGFja2FnZSI6WyIiXSwiYXBwbHluYW1lIjpbIipzaGVuZ3BheS5jb20iXSwicGxhdGZvcm0iOjR9'

// 这个是测试的
const DevLicense = 'RlBHaGZMMGVYVkxyZ1NQbU9QNk4rMWVkM25PcmpHMlhWaDJ3Si9NSGp6ejFYZUl4clNwMEt1R1ZpMWJLeGcwcWJXZGFDVWJkcFk2bjVrRlpEU1pIdzRSWkJ6WEI3MHV3NDhjU2RJTUpUZDBlWUNxZFpBekJpSHk3VHVKTWUvaEVsdWVCcDhzMTRqZ2FubE5iWFd5TDQvbmd1QnNYV081NDNBUGpiNEZIU0hJPXsiaWQiOjAsInR5cGUiOiJwcm9kdWN0IiwicGFja2FnZSI6WyIiXSwiYXBwbHluYW1lIjpbImxvY2FsaG9zdCJdLCJwbGF0Zm9ybSI6NH0='

// 这个是正式的
const DefaultLicense = 'bmpYYzN2NjY0dm5jSFBSbTRQZ25OT1hkNTM2SGJwV1JWZ1hBd3MxTzQ4Tm9xelJCQ1VPU0k4T0JFa1gxaGxNcTJKRUxTemFMOXBhQ3k3SHk0NWZXNS80NHlCSGZEdnRPSUFnSFo2V3BhYXZOd09ueEs4cW9GcHdHaEZIODE0U3NLK2l2WW0vOVBUN3V2clZuU1RjZ3ZlUzdjM3kwM21SdzRGZitKZHE4QzRjPXsiaWQiOjAsInR5cGUiOiJwcm9kdWN0IiwicGFja2FnZSI6WyIiXSwiYXBwbHluYW1lIjpbIipzaGVuZ3BheS5jb20iLCIqcWlla2UuY29tIl0sInBsYXRmb3JtIjo0fQ=='

let license = import.meta.env.DEV ? DevLicense : DefaultLicense

const licenseUOSAMD = 'SStvNHFVM0dZZW1oSk5wdytRZlBIV0lTQ084NEtwNThOeUdsUlVsaWx1QkptMzI1ZndqYXEwS2JudVJ4VVdTSTBaaWFRRTdiL2pxYjBYcjFwN0JTVWtSemd2Wk5pQmJyaVVnSzEwVWtKVjY2RXBLamEzVUx3V2FXVTBvMFFwWHBXYWJGc3B5TkJ0YlR0T3NNVkJSek9HVFY4NUc2bUhhRDJDbkV3NVVkVWVRPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjE0LCJub3RiZWZvcmUiOiIyMDIyMTIyMyIsIm5vdGFmdGVyIjoiMjAyMzA2MjMifQ=='
const licenseUOSMIPS = 'SFZpcWJOb2FPeXIrUjl2VjFXY3RLd0xZNXFmdS82Z3p3dXVlbWhIT3F6QVYvZVVWTTFOUTkvZGFoS0I0b0JZUWZCdFh3dnhzaHZrbDJ2eHhUOEZoNGNMUGxMMDlJVzBPZmNGbDEvc3lIcVNHSXR5OWpmeW9wVkZFc1BiMUtoZWdzMmlvM2RlY1hLc041MURucmZ4dDR3YzFndmFsQnRkQWFtQVlqTVdveWp3PXsiaWQiOjAsInR5cGUiOiJwcm9kdWN0IiwicGFja2FnZSI6WyIiXSwiYXBwbHluYW1lIjpbIipiYW5rb2ZiZWlqaW5nLmNvbS5jbiIsIipiai5ib2IiXSwicGxhdGZvcm0iOjE2fQ=='
const licenseUOSARM = 'T3lidU5IWVdGLzNmMkIyVmtBbEdoa3ZHbW9VMFhsc0dzbXN3UzhLelhXQ2RSUGNwRzRtRjNRcDNKbmJQcEhRc1JzRFNOYjU5UC8yMnNqSllCNWd2OVJ0Ymx5dnNQeGlIdE4xSStEbWExQzVGNnZYUTBOUU8rQXFYQUxGRndCZDdKRjk4anBNOEVQSnk2MEQ0M0F6UzdzVEhTbjZNZk1PYTRqNmtxYWFTQjZrPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjE4LCJub3RiZWZvcmUiOiIyMDIyMTIyMyIsIm5vdGFmdGVyIjoiMjAyMzA2MjMifQ=='
const licenseUOSSW = 'VUR1b21rVElyN0lzbFZhN0tqaU9BbEltQzlkSTRuS25XQk8wOFJPTWkwZzNBdTlQK2VlY3FJMGdFd2lPanoxemhCQlNFV0FIZzhxQmxxQjRZM25oYm1OTFUyM0k0ZWFLUENQV2toUWRLeGx1OXY0ck9hN0xHRDJuWXUvM1QxblFoVDdxY2RXWkljSTBON2RuNW1qdUZKS3hBRlF0VmFZS0lqeC8zcWxhNjh3PXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjM4LCJub3RiZWZvcmUiOiIyMDIzMDMyOSIsIm5vdGFmdGVyIjoiMjAyMzA5MjkifQ=='

// KY+AMD64
// KY+MIPS64
// KY+ARM64
// KY+SW64
const licenseKYAMD = 'aTl1RDd5Vi9jckkrQkpIQ3JkK2twbldqVklzamdmcEZBeW5Nb0VtaU1JNXpqR2JadzgxTDFQaGg2UDNzZHFpNWxkQVJQNGV0VzNxZEFTZXpXNHZMS2puM0FIMUhHRDdTSXF3aXZxRWlyQ1pINkZybjdDbUFXTGJzVmFRMlVlRERQWjZPdnp5RERYTkl1R04zbEVpajEvSVU4VHRNZTFHWHFtb1lac1VyZXhzPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjIyLCJub3RiZWZvcmUiOiIyMDIyMTIyMyIsIm5vdGFmdGVyIjoiMjAyMzA2MjMifQ=='
const licenseKYMIPS = 'ZmoyR2tGTFh6QU5XNjRnMHRhUDFLK0VUL2JjTWY0THNTNjhkNEJVUTVqK3ZmeVJBN2pNWU5sV0JmcC9sOVE0ZHJYL1FHNFZyOWR3VFYxTHUzc3RHK3VCMmZZcW1zYjkxUEZ5MDRseGswNHpEaWNrRHFpeVdoTlBEQXRCTWhBdmg4dWhqUzFSRXNEa2ViNU85bU9sUVM2WDZQNE1NdHpmendWSXpDeDdqNytRPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjI0LCJub3RiZWZvcmUiOiIyMDIyMTIyMyIsIm5vdGFmdGVyIjoiMjAyMzA2MjMifQ=='
const licenseKYARM = 'TU1WU1BzTmFjcUdSTk11THA0Q0M4aVhpRnl1blJtM0tmZXFCWFNVRmxIeWZ6QVFqYTI5ckNxaUVTWURvR2VvYlpDTlg3cFkyRlRzOU9GRXhmalJ1OEVZWk1xRFYyQTVxL1d1L2Nxa3Nia3N4VUJDcVpKbnZlOTJSOFl4ZTJaalRtbzlQbWxveHlWd3gzaGJPVDVBUlFOTVQyY1pzUjBNT2NLTjA0ekZPZmxJPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjI2LCJub3RiZWZvcmUiOiIyMDIyMTIyMyIsIm5vdGFmdGVyIjoiMjAyMzA2MjMifQ=='
const licenseKYSW = 'TzFvRG9iSE4yWUFxL3V5SXRlR004cDFuNE5sNyt1cmxPY3hwMTdvZHE2aU5sMDdkOHpDcFJCdDRVZ21IVytnRnM1cjRoNGRZY0xzWXJHV2tmZG9kU2RoMUFlQlNUVlhqNnFqaWtaa09hbnhxTkhtZ0cvTVliVzZOU2dDcU1HUU9wVG9Ya2d5SXVCVUVGOFl3NDN3aGY1Ry9OYzNDTElQYVJLdHlENFo5ZmprPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjQwLCJub3RiZWZvcmUiOiIyMDIyMDkwNyIsIm5vdGFmdGVyIjoiMjAyMzAzMDcifQ=='

// NKY+AMD64
// NKY+MIPS64
// NKY+ARM64
// NKY+SW64
const licenseNKYAMD = 'Rmw2QXZZUGcyU21jb3FOSmdBZER1U1kvQk8zT3lGK1QzcjQyZk5UUjVodm53eGM2cWpBLzdYMmFLQ3piTlBEeHg5SDNyTlA1LzFIK1hsK25jMFB3QXc3UWJRWUM3aFFvekFLVzJqTUMrR08rK1FxSC8xQkdlSXlpZ1d6eUpGK1U1dnl2STVLNXl3UzM0dTcwU3lWODNiSGRHYzMrQTlZaGtrQlV3YlhHVjE0PXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjMwLCJub3RiZWZvcmUiOiIyMDIwMTAzMCIsIm5vdGFmdGVyIjoiMjAyMTAxMzAifQ=='
const licenseNKYMIPS = 'Q3pYZjhwN3hHODFyZVpDZjMwZ3kyVWZ1bVE1c0g5eXFOeHFVR0NLdVUySlk5czQxVlBTZm0xVzdwQWFBQndWZC90NjZmd3lHaVNsZkxIUThHV0tjOTBtOUNvSXM3Uy9hdGIrK3pMbHVBcDZvVVFITVNxdzhWOEFFRXkyQjRWTXVJQXIvamNoY05kbTJJYldHUVJHUk1raHBFc0FSR1lJN0VEaEd5bTkwY2dZPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjMyLCJub3RiZWZvcmUiOiIyMDIwMTAzMCIsIm5vdGFmdGVyIjoiMjAyMTAxMzAifQ=='
const licenseNKYARM = 'R09SZkVSS2Y5eitFL3NPRW9kSTRHTmQzM0JPTEF0dFB1L1RTV3A2akNKbHVsY21DWEE5UnJubks2RG9IajNTNFNmTmNWeVhUTTNGV3NWVzhBNFU4ZmlFTkp5SFdLMk5hWXJCRTIzVVpUSEM4VHg4eHRIVmxIa3FXNHM2NmxQejNNQWozRHNnVjcrUTV0U0JIT2cxQUdnQStMYklTdUhueGVwSWx0amxSVGFFPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjM0LCJub3RiZWZvcmUiOiIyMDIwMTAzMCIsIm5vdGFmdGVyIjoiMjAyMTAxMzAifQ=='

let plats = 1// 1:AMD64,2:MIPS,3:ARM64,4:SW64;

const licenseMac = 'bkExTHVKMGlhSVZKNkVHdXprMHNmTFV2WUUrMGlIemVET2pGOTgxV2ovZEhpY2ZZcHQrWEpuTVRmWEJiV2g4YnZyT2dHTkVrNStINmdyK1ZGaHZOVGsyaDF1cTE2dHFLSFg3SzhXaS9OaDdBMDdsV1RpYTEwcHY1SDZnRVpKTjF4SVNrL1FTc0RpYVljSlpNVHYyVDluNmZzRXBKeFM2akVEZ21kME9NZG1rPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjgsIm5vdGJlZm9yZSI6IjIwMjMwNDIxIiwibm90YWZ0ZXIiOiIyMDIzMTAyMSJ9'
const urlPar = 'aHR0cDovLzE5Mi4xNjguMS4xMTg6ODA4Ny8='
let isLinux = false
// 设置是否升级 0:可选升级;1:强制升级
const PGEdit_Update = '0'; const installText = '请点此安装控件 (安装成功后请刷新页面)'; const upText = '请点此升级控件'; const logFlag = true// 日志开关
// Windows & Mac OS 非插件下用到的一些变量
let PGEdit_Edge_URL = 'https://localhost'; let port = 6856; const lastPort = port + 4
const CIJSON = { interfacetype: 0, data: { switch: 3 } }// 检查控件是否安装
const ICJSON = { interfacetype: 0, data: { switch: 2 } }// 实例化控件窗口
let INCJSON = { interfacetype: 1, data: {} }// 初始化控件参数
const OPJSON = { interfacetype: 0, data: { switch: 0 } }// 开启控件保护
const XTJSON = { interfacetype: 0, data: { switch: 5 } }// 心跳监测
const CPJSON = { interfacetype: 0, data: { switch: 1 } }// 关闭控件保护
const OUTJSON = { interfacetype: 2, data: {} }// 获取值类json串
const CLPJSON = { interfacetype: 0, data: { switch: 4 } }// 清空密码
// 心跳监听变量、集合、本地服务地址、日志开关、全局检测安装变量
let isInstalled = -1; let objVersion = ''; let interv; let urls; const onceInterv = {}; const iterArray = []
let asynctempwai
const inFlag = {}; let datac; let RZCIJSON
let pges = []// 控制是否能输入
const pgePoll = []
if (!navigator.userAgent.includes('MSIE'))
  navigator.plugins.refresh() // 非IE需要刷新plugins数组
function pge(option) {
  this.settings = {}
  if (option)
    this.settings = option

  this.pgeDownText = installText
  this.osBrowser = this.checkOsBrowser()
  if (this.osBrowser != 10 && this.osBrowser != 11)
    this.pgeVersion = this.getVersion()

  isInstalled = this.checkInstall()
  if (this.settings.pgeId) {
    for (let i = 0; i < pges.length; i++) {
      if (this.settings.pgeId == pges[i].settings.pgeId)
        pges.splice(i, 1)
    }
    pges.push(this)
    inFlag[this.settings.pgeWindowID] = { flag: false }
    pgePoll[this.settings.pgeWindowID] = this
  }
}
// 脚本版本号
pge.apiVersion = '2.0'
// 设置授权license
pge.prototype.setLicense = function () {
  if (isInstalled) {
    const control = document.getElementById(this.settings.pgeId)
    if (this.osBrowser == 1 || this.osBrowser == 3)
      control.license = license
  }
}
// 给控件设置随机因子
pge.prototype.pwdSetSk = function (s) {
  if (isInstalled) {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3 || this.osBrowser == 6 || this.osBrowser == 8) {
        control.input1 = s
      }
      else if (this.osBrowser == 2) {
        control.input(1, s)
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        INCJSON = { interfacetype: 1, data: {} }
        INCJSON.id = id, INCJSON.data.aeskey = s
        this.pwdGetData(INCJSON, '2000')
      }
    }
    catch (err) { }
  }
}
// 获得密码长度*/
pge.prototype.pwdLength = function () {
  let code = 0
  if (!isInstalled) {
    code = 0
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output3
      }
      else if (this.osBrowser == 2) {
        code = control.output(3)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output3()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 3, OUTJSON.data.encrypt = 0
        code = this.pwdGetData(OUTJSON, '2001')
      }
    }
    catch (err) { code = 0 }
  }
  return code
}
// 获得密码的Hash值
pge.prototype.pwdHash = function () {
  let code = 0
  if (!isInstalled) {
    code = 0
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output2
      }
      else if (this.osBrowser == 2) {
        code = control.output(2)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output2()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 2, OUTJSON.data.encrypttype = 1
        code = this.pwdGetData(OUTJSON, '2002')
      }
    }
    catch (err) { code = 0 }
  }
  return code
}
pge.prototype.setIePlaceholder = function () {
  if (isInstalled) {
    const control = this.pwdGetEById(this.settings.pgeId)
    if (!control)
      return
    if (this.osBrowser == 1 || this.osBrowser == 3) {
      if (this.settings.pgePlaceholder != undefined && this.settings.pgePlaceholder != '')
        control.input12 = this.settings.pgePlaceholder
      if (this.settings.placeholderFontColor != undefined && this.settings.placeholderFontColor != '')
        control.ForeColor = this.settings.placeholderFontColor
      if (this.settings.placeholderFont != undefined && this.settings.placeholderFont != '')
        control.FontName = this.settings.placeholderFont
      if (this.settings.placeholderSize != undefined && this.settings.placeholderSize != '')
        control.FontSize = this.settings.placeholderSize
      if (this.settings.placeholderBackColor != undefined && this.settings.placeholderBackColor != '')
        control.BackColor = this.settings.placeholderBackColor
    }
  }
}
// 判断是否是简单密码
pge.prototype.pwdSimple = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output44
      }
      else if (this.osBrowser == 2) {
        code = control.output(13)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output12()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 13, OUTJSON.data.encrypttype = 1
        code = this.pwdGetData(OUTJSON, '2003')
      }
    }
    catch (err) { code = '' }
  }
  return code
}
// 获得密码的强度(强度的规则可调整)
pge.prototype.pwdStrength = function () {
  let code = 0
  if (!isInstalled) {
    code = 0
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        var len = control.output3
        var num = control.output4
        var zoom = control.output54
      }
      else if (this.osBrowser == 2 || this.osBrowser == 4 || this.osBrowser == 5) {
        var len = control.output(3)
        var num = control.output(4)
        var zoom = control.output(4, 1)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        var len = control.get_output3()
        var num = control.get_output4()
        var zoom = control.get_output16()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 3, OUTJSON.data.encrypttype = 0
        var len = this.pwdGetData(OUTJSON, '2001')
        OUTJSON.data.datatype = 4, OUTJSON.data.encrypttype = 0
        var num = this.pwdGetData(OUTJSON, '2004')
        OUTJSON.data.datatype = 4, OUTJSON.data.encrypttype = 1
        var zoom = this.pwdGetData(OUTJSON, '2005')
      }
      if (len < 6)
        code = 0
			 else if (num == 1)
        code = 1 // 弱
			 else if (num == 2)
        code = 2 // 中
			 else if (num == 3)
        code = 3 // 强
    }
    catch (err) { code = 0 }
  }
  return code
}
// 判断是否匹配正则2
pge.prototype.pwdValid = function () {
  let code = 1
  if (!isInstalled) {
    code = 1
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        if (control.output1)
          code = control.output5
      }
      else if (this.osBrowser == 2) {
        code = control.output(5)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output5()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 5, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2006')
      }
    }
    catch (err) { code = 1 }
  }
  return code
}
// 获得密码字符类型个数
pge.prototype.pwdNum = function () {
  let code = 0
  if (!isInstalled) {
    code = 0
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output4
      }
      else if (this.osBrowser == 2) {
        code = control.output(4)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.output4()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 4, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2004')
      }
    }
    catch (err) { code = 0 }
  }
  return code
}
// 清空密码
pge.prototype.pwdClear = function (windowid, pgeId) {
  if (isInstalled) {
    if (this.osBrowser == 10 || this.osBrowser == 11) {
      let id = this.settings.pgeWindowID
      let inputID = this.settings.pgeId
      if (windowid && pgeId) {
        id = windowid
        inputID = pgeId
      }
      const tempo = this.pwdGetEById(inputID)
      if (!tempo)
        return

      CLPJSON.id = id
      this.pwdGetData(CLPJSON, '2007')
      tempo.value = ''
    }
    else {
      document.getElementById(this.settings.pgeId)?.ClearSeCtrl()
    }
  }
},
// 获得密码AES密文
pge.prototype.pwdResult = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output1
      }
      else if (this.osBrowser == 2) {
        code = control.output(7)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output1()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        OUTJSON.id = this.settings.pgeWindowID, OUTJSON.data.datatype = 7, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2008')
      }
    }
    catch (err) { code = '' }
  }
  return code
},
// 获得密码SM4+SM2密文
pge.prototype.pwdResultSM = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const sm = `${this.settings.AffineX}|${this.settings.AffineY}`
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        control.input10 = '1'
        control.input7 = sm
        code = control.output104
      }
      else if (this.osBrowser == 2) {
        control.input(200, sm)
        code = control.output(7, 12)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        control.input13 = sm
        code = control.get_output22()
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        OUTJSON.id = this.settings.pgeWindowID, OUTJSON.data.datatype = 7, OUTJSON.data.encrypttype = 12
        code = this.pwdGetData(OUTJSON, '2008')
      }
    }
    catch (err) { code = '' }
  }
  return code
},
// 获得计算机硬件信息列表密文
pge.prototype.machineList = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.output58
      }
      else if (this.osBrowser == 2) {
        code = control.output(15)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output20(0)
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 15, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2009')
      }
    }
    catch (err) { code = '' }
  }
  return code
}

// 获得计算机Mac信息密文
pge.prototype.machineNetwork = function (s) {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.GetIPMacList()
      }
      else if (this.osBrowser == 2) {
        code = control.output(9)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output7(0)
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        var id = this.settings.pgeWindowID
        INCJSON = { interfacetype: 1, data: {} }
        INCJSON.id = id, INCJSON.data.aeskey = s
        this.pwdGetData(INCJSON, '2000')

        var id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 9, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2009')
      }
    }
    catch (err) { code = '' }
  }
  return code
}
// 获得计算机硬盘信息密文
pge.prototype.machineDisk = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.GetNicPhAddr(1)
      }
      else if (this.osBrowser == 2) {
        code = control.output(11)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output7(2)
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 11, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2010')
      }
    }
    catch (err) { code = '' }
  }
  return code
},
// 获得计算机cpu信息密文
pge.prototype.machineCPU = function () {
  let code = ''
  if (!isInstalled) {
    code = ''
  }
  else {
    try {
      const control = this.pwdGetEById(this.settings.pgeId)
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        code = control.GetNicPhAddr(2)
      }
      else if (this.osBrowser == 2) {
        code = control.output(10)
      }
      else if (this.osBrowser == 6 || this.osBrowser == 8) {
        code = control.get_output7(1)
      }
      else if (this.osBrowser == 10 || this.osBrowser == 11) {
        const id = this.settings.pgeWindowID
        OUTJSON.id = id, OUTJSON.data.datatype = 10, OUTJSON.data.encrypttype = 0
        code = this.pwdGetData(OUTJSON, '2011')
      }
    }
    catch (err) { code = '' }
  }
  return code
}
// 获得控件版本号
pge.prototype.getVersion = function () {
  try {
    if (this.osBrowser == 1 || this.osBrowser == 3) {
      const comActiveX = new ActiveXObject(PGEdit_IE_ProgId)
      return comActiveX.output35
    }
    else if (this.osBrowser == 2 || this.osBrowser == 6 || this.osBrowser == 8) {
      let arr = []; var pge_version
      const pge_info = navigator.plugins[PGEdit_FF_PluginName].description
      if (pge_info.indexOf(':') > 0) {
        arr = pge_info.split(':')
        pge_version = arr[1]
      }
      else {
        pge_version = ''
      }
    }
    else if (this.osBrowser == 10 || this.osBrowser == 11) {
      if (isInstalled == -1 || !isInstalled)
        return
      const id = this.settings.pgeWindowID
      OUTJSON.id = id, OUTJSON.data.datatype = 12, OUTJSON.data.encrypttype = 0
      this.pwdJsonp(OUTJSON, '1006', id, inputID)
    }
    return pge_version
  }
  catch (err) { }
}
// 检测操作系统和浏览器信息
pge.prototype.checkOsBrowser = function () {
  let userosbrowser; const usera = navigator.userAgent; const regStr_chrome = /chrome\/[\d.]+/gi; const regStr_firefox = /Firefox\/[\d.]+/gi
  if ((navigator.platform == 'Win32') || (navigator.platform == 'Win')) {
    if ((usera.indexOf('MSIE') > 0) || (usera.indexOf('msie') > 0) || (usera.indexOf('Trident') > 0) || (usera.indexOf('trident') > 0)) {
      if (usera.indexOf('ARM') > 0) {
        userosbrowser = 9
        this.pgeditIEExe = ''
      }
      else {
        userosbrowser = 1
        this.pgeditIEExe = PGEdit_IE32_EXE
        this.pgeditIEClassid = PGEdit_IE_CLASSID
      }
    }
    else if (usera.indexOf('Edge') > 0) {
      userosbrowser = 10
      this.pgeditFFExe = PGEdit_Edge
    }
    else if (usera.indexOf('Chrome') > 0) {
      var chromeVersion = usera.match(regStr_chrome).toString()
      chromeVersion = parseInt(chromeVersion.replace(/[^0-9.]/gi, ''))
      if (chromeVersion > 42) {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
      else {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
    }
    else if (usera.indexOf('Firefox') > 0) {
      var firefoxVersion = usera.match(regStr_firefox).toString()
      firefoxVersion = parseInt(firefoxVersion.replace(/[^0-9.]/gi, ''))
      if (firefoxVersion >= 50) {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
      else {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
    }
    else {
      userosbrowser = 10
      this.pgeditFFExe = PGEdit_Edge
    }
  }
  else if (navigator.platform == 'Win64') {
    if ((usera.indexOf('Windows NT 6.2') > 0 || usera.indexOf('window nt 6.2') > 0) && !usera.includes('Firefox')) {
      userosbrowser = 1
      this.pgeditIEClassid = PGEdit_IE_CLASSID
      this.pgeditIEExe = PGEdit_IE32_EXE
    }
    else if (usera.indexOf('MSIE') > 0 || usera.indexOf('msie') > 0 || usera.indexOf('Trident') > 0 || usera.indexOf('trident') > 0) {
      userosbrowser = 3
      this.pgeditIEClassid = PGEdit_IE_CLASSID
      this.pgeditIEExe = PGEdit_IE64_EXE
    }
    else if (usera.indexOf('Edge') || usera.indexOf('Firefox') > 0) {
      userosbrowser = 10
      this.pgeditFFExe = PGEdit_Edge
    }
    else if (usera.indexOf('Chrome')) {
      var chromeVersion = usera.match(regStr_chrome).toString()
      chromeVersion = parseInt(chromeVersion.replace(/[^0-9.]/gi, ''))
      if (chromeVersion >= 42) {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
      else {
        userosbrowser = 10
        this.pgeditFFExe = PGEdit_Edge
      }
    }
    else {
      userosbrowser = 10
      this.pgeditFFExe = PGEdit_Edge
    }
  }
  else if (navigator.userAgent.indexOf('Macintosh') > 0) {
    PGEdit_Edge_URL = 'https://127.0.0.1'
    if (usera.indexOf('Safari') > 0 && (usera.indexOf('Version/5.1') > 0 || usera.indexOf('Version/5.2') > 0 || usera.indexOf('Version/6') > 0)) {
      userosbrowser = 11// macos
      this.pgeditFFExe = PGEdit_Edge_Mac
    }
    else if (usera.indexOf('Chrome') > 0 || usera.indexOf('Firefox') > 0) {
      var chromeVersion = usera.match(regStr_chrome)
      var firefoxVersion = usera.match(regStr_firefox)
      if (chromeVersion != null) {
        chromeVersion = chromeVersion.toString()
        chromeVersion = parseInt(chromeVersion.replace(/[^0-9.]/gi, ''))
        if (chromeVersion >= 42) {
          userosbrowser = 11
          this.pgeditFFExe = PGEdit_Edge_Mac
        }
        else {
          userosbrowser = 11
          this.pgeditFFExe = PGEdit_Edge_Mac
        }
      }
      if (firefoxVersion != null) {
        firefoxVersion = firefoxVersion.toString()
        firefoxVersion = parseInt(firefoxVersion.replace(/[^0-9.]/gi, ''))
        if (firefoxVersion >= 50) {
          userosbrowser = 11
          this.pgeditFFExe = PGEdit_Edge_Mac
        }
        else {
          userosbrowser = 11
          this.pgeditFFExe = PGEdit_Edge_Mac
        }
      }
    }
    else if (navigator.userAgent.includes('QQBrowserLite')) {
      userosbrowser = 11
      this.pgeditFFExe = PGEdit_Edge_Mac
    }
    else if (usera.indexOf('Opera') > 0 && (navigator.userAgent.indexOf('Version/11.6') > 0 || navigator.userAgent.indexOf('Version/11.7') > 0)) {
      userosbrowser = 11
      this.pgeditFFExe = PGEdit_Edge_Mac
    }
    else if (navigator.userAgent.includes('Safari')) {
      const regStr_mac = /Version\/[\d.]+/gi
      let num = navigator.userAgent.match(regStr_mac).toString()
      num = parseInt(num.replace(/[^0-9.]/gi, ''))

      if (num >= 12) {
        userosbrowser = 11
        this.pgeditFFExe = PGEdit_Edge_Mac
      }
      else {
        userosbrowser = 11// macos
        this.pgeditFFExe = PGEdit_Edge_Mac
      }
    }
    else {
      userosbrowser = 0
      this.pgeditFFExe = ''
    }
  }
  else if (navigator.userAgent.indexOf('Linux') > 0) { // linux
    // installText = "请下载控件并安装";
    userosbrowser = 10
    isLinux = true
    this.pgeditFFExe = 'passguard_xc.zip'
    if (navigator.userAgent.includes('mips64')) {
      plats = 2
    }
    else if (navigator.userAgent.includes('x86_64')) {
      plats = 1
      this.pgeditFFExe = PGEdit_LinuxamdUOSAKL
    }
    else if (navigator.userAgent.includes('aarch64')) {
      plats = 3
      this.pgeditFFExe = PGEdit_LinuxarmUOSAKL
    }
    else if (navigator.userAgent.includes('loongarch64')) {
      plats = 4
    }
    else if (navigator.userAgent.includes('i386') || navigator.userAgent.includes('i486') || navigator.userAgent.includes('i586') || navigator.userAgent.includes('i686')) {
      plats = 5
    }
  }
  return userosbrowser
}
// 获得控件绘制标签代码
pge.prototype.getPgeHtml = function () {
  if (this.osBrowser == 1 || this.osBrowser == 3) {
    return `<OBJECT ID="${this.settings.pgeId}" CLASSID="CLSID:${this.pgeditIEClassid}" codebase="${
			 this.settings.pgePath}${this.pgeditIECab}" onkeydown="if(13==event.keyCode || 27==event.keyCode)${this.settings.pgeOnKeyDown};" tabindex="${this.settings.pgeTabIndex}" class="${this.settings.pgeClass}">`
			+ `<param name="edittype" value="${this.settings.pgeEditType}"><param name="maxlength" value="${this.settings.pgeMaxLength}"><param name="input58" value="${this.settings.pgeOnFocus}"><param name="input59" value="${this.settings.pgeOnBlur}">`
			+ `<param name="input2" value="${this.settings.pgeEreg1}"><param name="input3" value="${this.settings.pgeEreg2}"></OBJECT>`
  }
  else if (this.osBrowser == 2) {
    let ff = ''
    if (navigator.userAgent.includes('SE 2.X') || navigator.userAgent.includes('OPR'))
      ff = 'this.focus();'

    let pgeOcx = `<embed onmouseover="${ff}" onfocus="${this.settings.pgeOnFocus}" input_0 ="${license}" onblur="${this.settings.pgeOnBlur}" ID="${this.settings.pgeId}"  maxlength="${this.settings.pgeMaxLength}" input_2="${this.settings.pgeEreg1}" input_3="${this.settings.pgeEreg2}" edittype="${this.settings.pgeEditType}" type="application/${PGEdit_FF_MIMETYPE}" tabindex="${this.settings.pgeTabIndex}" class="${this.settings.pgeClass}" `
    if (this.settings.pgeOnKeyDown != undefined && this.settings.pgeOnKeyDown != '')
      pgeOcx += ` input_1013="${this.settings.pgeOnKeyDown}"`
    if (this.settings.tabCallBack != undefined && this.settings.tabCallBack != '')
      pgeOcx += ` input_1009="setTimeout(function(){document.getElementById('${this.settings.tabCallBack}').focus();},20);"`
    if (navigator.userAgent.includes('Chrome') || navigator.userAgent.includes('Safari')) {
      if (this.settings.pgeOnFocus != undefined && this.settings.pgeOnFocus != '')
        pgeOcx += ` input_1010="${this.settings.pgeOnFocus}"`
      if (this.settings.pgeOnBlur != undefined && this.settings.pgeOnBlur != '')
        pgeOcx += ` input_1011="${this.settings.pgeOnBlur}"`
    }
    if (this.settings.pgeFontName != undefined && this.settings.pgeFontName != '')
      pgeOcx += ` FontName="${this.settings.pgeFontName}"`
    if (this.settings.pgeFontSize != undefined && this.settings.pgeFontSize != '')
      pgeOcx += ` FontSize=${Number(this.settings.pgeFontSize)}`
    if (this.settings.placeholderBackColor != undefined && this.settings.placeholderBackColor != '')
      pgeOcx += `input_601="${this.settings.placeholderBackColor}" `
    if (this.settings.pgePlaceholder != undefined && this.settings.pgePlaceholder != '')
      pgeOcx += `input_600="${this.settings.pgePlaceholder}" `
    if (this.settings.placeholderFontColor != undefined && this.settings.placeholderFontColor != '')
      pgeOcx += `input_602="${this.settings.placeholderFontColor}" `
    if (this.settings.placeholderFont != undefined && this.settings.placeholderFont != '')
      pgeOcx += `input_603="${this.settings.placeholderFont}" `
    if (this.settings.placeholderSize != undefined && this.settings.placeholderSize != '')
      pgeOcx += `input_604="${this.settings.placeholderSize}" `
    pgeOcx += '/>'
    return pgeOcx
  }
  else if (this.osBrowser == 6 || this.osBrowser == 8) {
    return `<embed ID="${this.settings.pgeId}" tabCallBack = "${this.settings.pgeMacTabCB}" setlic ="${licenseMac}" losefocuscallback="${this.settings.pgeOnBlur}" havefocuscallback="${this.settings.pgeOnFocus}" input2="${this.settings.pgeEreg1}"  input3="${this.settings.pgeEreg2}" input4="${Number(this.settings.pgeMaxLength)}" input0="${Number(this.settings.pgeEditType)}" type="application/${PGEdit_MacOs_MIMETYPE}" version="${PGEdit_MacOs_VERSION}" tabindex="${this.settings.pgeTabIndex}" class="${this.settings.pgeClass}"/>`
  }
  else if (this.osBrowser == 10 || this.osBrowser == 11) {
    /* if((this.getConvertVersion(objVersion)<this.getConvertVersion(PGEdit_Edge_VERSION))&&PGEdit_Update=="1"){
			var winPath = this.settings.pgePath+this.pgeditFFExe;
			return '<div id="'+this.settings.pgeId+'_down" class="'+this.settings.pgeInstallClass+'" style="text-align:center;line-height:25px;"><a href="'+this.settings.pgePath+this.pgeditFFExe+'">'+this.pgeDownText+'</a></div>';
		} */
    // else{
    return `<div id="${this.settings.pgeId}_down" class="${this.settings.pgeInstallClass}" style="text-align:center;line-height:25px;"><a href="${this.settings.pgePath}${this.pgeditFFExe}">${this.pgeDownText}</a></div>`
    // }
  }
  else {
    return `<div id="${this.settings.pgeId}_down" class="${this.settings.pgeInstallClass}" style="text-align:center;">暂不支持此浏览器</div>`
  }
},
pge.prototype.getJsVersion = function () {
  let jsVersion = ''
  if (this.osBrowser == 1)
    jsVersion = PGEdit_IE32_VERSION
  if (this.osBrowser == 2)
    jsVersion = PGEdit_FF_VERSION
  if (this.osBrowser == 3)
    jsVersion = PGEdit_IE64_VERSION
  if (this.osBrowser == 6 || this.osBrowser == 8)
    jsVersion = PGEdit_MacOs_VERSION
  return jsVersion
},
// 用document.write()绘制控件标签代码
pge.prototype.generate = function () {
  if (this.osBrowser == 10 || this.osBrowser == 11)
    return document.write(this.getPgeHtml())
  if (!isInstalled) {
    return document.write(this.getDownHtml())
  }
  else {
    const jsVersion = this.getJsVersion()
    if ((this.getConvertVersion(this.pgeVersion) < this.getConvertVersion(jsVersion)) && PGEdit_Update == 1) {
      this.setDownText()
      return document.write(this.getPgeHtml())
    }
  }
  return document.write(this.getPgeHtml())
},
// 返回控件绘制标签代码
pge.prototype.load = function () {
  if (this.osBrowser == 10 || this.osBrowser == 11)
    return this.getPgeHtml()
  if (!isInstalled) {
    return this.getDownHtml()
  }
  else {
    const jsVersion = this.getJsVersion()
    if (this.getConvertVersion(this.pgeVersion) < this.getConvertVersion(jsVersion) && PGEdit_Update == 1) {
      this.setDownText()
      return this.getDownHtml()
    }
  }
  return this.getPgeHtml()
},
// 返回提示下载的标签代码
pge.prototype.getDownHtml = function () {
  if (this.osBrowser == 1 || this.osBrowser == 3)
    return `<div id="${this.settings.pgeId}_down" class="${this.settings.pgeInstallClass}" style="text-align:center;line-height:28px;"><a href="${this.settings.pgePath}${this.pgeditIEExe}">${this.pgeDownText}</a></div>`
		 else if (this.osBrowser == 2 || this.osBrowser == 6 || this.osBrowser == 8 || this.osBrowser == 10 || this.osBrowser == 11)
    return `<div id="${this.settings.pgeId}_down" class="${this.settings.pgeInstallClass}" style ="text-align:center;line-height:25px;"><a href="${this.settings.pgePath}${this.pgeditFFExe}">${this.pgeDownText}</a></div>`
		 else
    return `<div id="${this.settings.pgeId}_down" class="${this.settings.pgeInstallClass}"style ="text-align:center";>暂不支持此浏览器</div>`
},
// 检测控件是否已安装
pge.prototype.checkInstall = function (s, callf, asynctemp) {
  try {
    if (this.osBrowser == 1 || this.osBrowser == 3) {
      const comActiveX = new ActiveXObject(PGEdit_IE_ProgId)
      return true
    }
    else if (this.osBrowser == 2 || this.osBrowser == 6 || this.osBrowser == 8) {
      let arr = []; let pge_version
      const pge_info = navigator.plugins[PGEdit_FF_PluginName].description
      if (pge_info.indexOf(':') > 0) {
        arr = pge_info.split(':')
        pge_version = arr[1]
        if (pge_version != '')
          return true
      }
      else {
        pge_version = ''
        return false
      }
    }
    else if ((this.osBrowser == 10 || this.osBrowser == 11) && s == 1) {
      const id = CIJSON.id = this.settings.pgeWindowID
      urls = `${PGEdit_Edge_URL}:${port}`
	  this.settings.asynctemp = asynctemp
	  asynctempwai = asynctemp
	  this.pwdJsonp(CIJSON, '1000', id, '', callf)
    }
  }
  catch (err) {
    return false
  }
  return true
}
// 发同步ajax请求
pge.prototype.pwdGetData = function (datas, type) {
  const datac = this.getEnStr(this.settings.pgeRZRandNum, datas)
  const RZCIJSON = { rankey: this.settings.pgeRZRandNum, datab: this.settings.pgeRZDataB, datac }
  let d = 0; let typeStr = ''
  if (type == '2000')
    typeStr = 'set random'
  if (type == '2001')
    typeStr = 'get length'
  if (type == '2002')
    typeStr = 'get hash'
  if (type == '2003')
    typeStr = 'get simple'
  if (type == '2004')
    typeStr = 'get pwdnums'
  if (type == '2005')
    typeStr = 'get pwdnumstwo'
  if (type == '2006')
    typeStr = 'pwd valid'
  if (type == '2007')
    typeStr = 'clear pwd'
  if (type == '2008')
    typeStr = 'get pwdresult'
  if (type == '2009')
    typeStr = 'get mac'
  if (type == '2010')
    typeStr = 'get harddisk'
  if (type == '2011')
    typeStr = 'get cpu'
  datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
  Ajax.request({
    url: urls,
    timeout: 2000,
    type: 'GET',
    async: false,
    data: {
      jsoncallback: 'jsoncallback',
      str: datas,
      type: typeStr,
    },
    success(x) {
      x = x.responseText
      x = x.substring(13, x.length - 1)
      x = JSON.parse(x)
      d = x.data
    },
    error(x) {
      d = -1
    },
  })
  return d
}
const pgeRZRandNum = 'FB976FCC1291467AB43E5BF5A178120A'
const pgeRZDataB = 'fj5qLJhRQPEnaYuENG/mYCIqVToP/T98lWdnAqK5Uxs='

function pwdJsonp(datas, type, id, inputID, callf, callf2) {
  const datac = getEnStr(pgeRZRandNum, datas)
  const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
  let typeStr = ''; let timenums = 5000
  if (type != '1000')
    timenums = 20000
  if (type == '1000')
    typeStr = 'checkinstall'
  if (type == '1004')
    typeStr = 'initControl'
  if (type == '1001')
    typeStr = 'openProt'
  if (type == '1002')
    typeStr = 'intervlOut'
  if (type == '1003')
    typeStr = 'instControl'
  if (type == '1005')
    typeStr = 'closeProt'
  if (type == '1006')
    typeStr = 'get version'
  if (type == '1007')
    typeStr = 'check password type num'
  if (type == '1008')
    typeStr = 'check password type num'

  console.log('[[[[[[[[[[[[[[[[[[[[[[[wai pwdJsonp asynctemp', asynctempwai)
  if (asynctempwai == true) {
	  jsonp({
      url: urls,
      time: timenums,
      data: { str: JSON.stringify(RZCIJSON), jsoncallback: 'cb', type: typeStr },
      callback: 'jsoncallback',
      success(x) {
	  // datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
	  // try {
        // Ajax.request({
		  // url: urls,
		  // timeout: 2000,
		  // type: 'GET',
		  // async: false,
		  // data: {
        // jsoncallback: 'jsoncallback',
        // str: datas,
        // type: typeStr,
		  // },
		  // success(x) {
        // x = x.responseText
        // x = x.substring(13, x.length - 1)
        // x = JSON.parse(x)
        if (type == '1000') {
			  objVersion = x.data

			  const vers = objVersion.split('  ')
			  if (vers[1] == 1) {
            if (plats == 1) {
				  license = licenseUOSAMD
				  PGEdit_Edge_VERSION = PGEdit_UOSamd_VERSION
            }
            else if (plats == 2) {
				  license = licenseUOSMIPS
				  PGEdit_Edge_VERSION = PGEdit_UOSmips_VERSION
            }
            else if (plats == 3) {
				  license = licenseUOSARM
				  PGEdit_Edge_VERSION = PGEdit_UOSarm_VERSION
            }
            else if (plats == 4) {
				  license = licenseUOSSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 2) {
            if (plats == 1) {
				  license = licenseKYAMD
				  PGEdit_Edge_VERSION = PGEdit_KYamd_VERSION
            }
            else if (plats == 2) {
				  license = licenseKYMIPS
				  PGEdit_Edge_VERSION = PGEdit_KYmips_VERSION
            }
            else if (plats == 3) {
				  license = licenseKYARM
				  PGEdit_Edge_VERSION = PGEdit_KYarm_VERSION
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 3) {
            if (plats == 1) {
				  license = licenseNKYAMD
            }
            else if (plats == 2) {
				  license = licenseNKYMIPS
            }
            else if (plats == 3) {
				  license = licenseNKYARM
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 4) {
            if (plats == 1) {
				  license = licenseNKYAMD
            }
            else if (plats == 2) {
				  license = licenseNKYMIPS
            }
            else if (plats == 3) {
				  license = licenseNKYARM
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }

			  if (x.code == 0) {
            if (logFlag)
				  console.log('control is installed')
			  }
			  else {
            if (logFlag)
				  console.log(`code:${x.code}`)
			  }
			  if (callf)
            callf(obj)
        }
        else if (type == '1001') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('openProt success')
            }
            inFlag[id].flag = true
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1002') {
			  const code = parseInt(x.data)
			  if (logFlag) {
            console.log(`pgeWindowsID:${id}`)
            console.log(`x.data.length:${x.data},x.code:${x.code}`)
			  }
			  const va = pgeCtrl.pwdGetEById(inputID); const len = va.value.len; let y = ''; let i = 0
			  for (; i < code; i++) y += '*'
			  va.value = y
        }
        else if (type == '1003') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('inst success')
            }
            obj.initControl(id, '', callf, callf2)
			  }
			  else {
            const tempobj = pgeCtrl.pwdGetEById(inputID)

            if (tempobj)
				  tempobj.parentNode.innerHTML = `err,inst code:${x.code}`
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1004') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('init success')
            }
            inFlag[id] = { flag: false }
            if (callf)
				  callf(obj)
            if (window.isC2 == false)
				  if (callf2) { callf2(obj); window.isC2 = true }
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1005') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('closeProt success')
            }
            inFlag[id].flag = false
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
			  inFlag[id].id = false
        }
        else if (type == '1006') {
			  if (callf)
            callf(x.data)
        }
        else if (type == '1007') {
			  if (callf)
            callf(x.data)
        }
        else if (type == '1008') {
			  if (callf)
            callf(x.data)
        }
		  },
		  // error(x) {
      // d = -1
			   // if (type == '1000') {
				   // if (port < lastPort) {
      // port++
      // obj.checkInstall(1, callf)
				   // }
			  // else {
      // if (callf)
				  // callf(false)
			  // }
			   // }
		  // },
      // })
	  // }
	  // catch (err) {
		   // if (type == '1000') {
			   // if (port < lastPort) {
      // port++
      // obj.checkInstall(1, callf)
			   // }
		  // else {
      // if (callf)
			  // callf(false)
		  // }
		   // }
	  // }
	  fail(jqXHR, textStatus, errorThrown) {
        if (type == '1000') {
          if (port < lastPort) {
            port++
            obj.checkInstall(1, callf)
          }
          else { // checkInstall = false;

          }
        }
	  },
	  })
  }
  else {
	  datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
	  try {
      Ajax.request({
		  url: urls,
		  timeout: 2000,
		  type: 'GET',
		  async: false,
		  data: {
          jsoncallback: 'jsoncallback',
          str: datas,
          type: typeStr,
		  },
		  success(x) {
          x = x.responseText
          x = x.substring(13, x.length - 1)
          x = JSON.parse(x)
          if (type == '1000') {
			  objVersion = x.data

			  const vers = objVersion.split('  ')
			  if (vers[1] == 1) {
              if (plats == 1) {
				  license = licenseUOSAMD
				  PGEdit_Edge_VERSION = PGEdit_UOSamd_VERSION
              }
              else if (plats == 2) {
				  license = licenseUOSMIPS
				  PGEdit_Edge_VERSION = PGEdit_UOSmips_VERSION
              }
              else if (plats == 3) {
				  license = licenseUOSARM
				  PGEdit_Edge_VERSION = PGEdit_UOSarm_VERSION
              }
              else if (plats == 4) {
				  license = licenseUOSSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
			  }
			  else if (vers[1] == 2) {
              if (plats == 1) {
				  license = licenseKYAMD
				  PGEdit_Edge_VERSION = PGEdit_KYamd_VERSION
              }
              else if (plats == 2) {
				  license = licenseKYMIPS
				  PGEdit_Edge_VERSION = PGEdit_KYmips_VERSION
              }
              else if (plats == 3) {
				  license = licenseKYARM
				  PGEdit_Edge_VERSION = PGEdit_KYarm_VERSION
              }
              else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
			  }
			  else if (vers[1] == 3) {
              if (plats == 1) {
				  license = licenseNKYAMD
              }
              else if (plats == 2) {
				  license = licenseNKYMIPS
              }
              else if (plats == 3) {
				  license = licenseNKYARM
              }
              else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
			  }
			  else if (vers[1] == 4) {
              if (plats == 1) {
				  license = licenseNKYAMD
              }
              else if (plats == 2) {
				  license = licenseNKYMIPS
              }
              else if (plats == 3) {
				  license = licenseNKYARM
              }
              else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
			  }

			  if (x.code == 0) {
              if (logFlag)
				  console.log('control is installed')
			  }
			  else {
              if (logFlag)
				  console.log(`code:${x.code}`)
			  }
			  if (callf)
              callf(obj)
          }
          else if (type == '1001') {
			  if (x.code == 0) {
              if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('openProt success')
              }
              inFlag[id].flag = true
			  }
			  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1002') {
			  const code = parseInt(x.data)
			  if (logFlag) {
              console.log(`pgeWindowsID:${id}`)
              console.log(`x.data.length:${x.data},x.code:${x.code}`)
			  }
			  const va = pgeCtrl.pwdGetEById(inputID); const len = va.value.len; let y = ''; let i = 0
			  for (; i < code; i++) y += '*'
			  va.value = y
          }
          else if (type == '1003') {
			  if (x.code == 0) {
              if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('inst success')
              }
              obj.initControl(id, '', callf, callf2)
			  }
			  else {
              const tempobj = pgeCtrl.pwdGetEById(inputID)

              if (tempobj)
				  tempobj.parentNode.innerHTML = `err,inst code:${x.code}`
			  }
			  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1004') {
			  if (x.code == 0) {
              if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('init success')
              }
              inFlag[id] = { flag: false }
              if (callf)
				  callf(obj)
              if (window.isC2 == false)
				  if (callf2) { callf2(obj); window.isC2 = true }
			  }
			  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1005') {
			  if (x.code == 0) {
              if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('closeProt success')
              }
              inFlag[id].flag = false
			  }
			  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
			  inFlag[id].id = false
          }
          else if (type == '1006') {
			  if (callf)
              callf(x.data)
          }
          else if (type == '1007') {
			  if (callf)
              callf(x.data)
          }
          else if (type == '1008') {
			  if (callf)
              callf(x.data)
          }
		  },
		  error(x) {
          d = -1
			   if (type == '1000') {
				   if (port < lastPort) {
              port++
              obj.checkInstall(1, callf)
				   }
			  else {
              if (callf)
				  callf(false)
			  }
			   }
		  },
      })
	  }
	  catch (err) {
		   if (type == '1000') {
			   if (port < lastPort) {
          port++
          obj.checkInstall(1, callf)
			   }
		  else {
          if (callf)
			  callf(false)
		  }
		   }
	  }
	  // fail: function (jqXHR, textStatus, errorThrown) {
    // if (type == "1000") {
    // if (port < lastPort) {
    // port++;
    // obj.checkInstall(1, callf);

    // } else {//checkInstall = false;
    // return;
    // }
    // }
	  // }
	  // })
  }
}
// 发异步ajax请求
pge.prototype.pwdJsonp = function (datas, type, id, inputID, callf, callf2) {
  const datac = this.getEnStr(this.settings.pgeRZRandNum, datas); const obj = this
  const RZCIJSON = { rankey: this.settings.pgeRZRandNum, datab: this.settings.pgeRZDataB, datac }
  let typeStr = ''; let timenums = 5000
  if (type != '1000')
    timenums = 20000
  if (type == '1000')
    typeStr = 'checkinstall'
  if (type == '1004')
    typeStr = 'initControl'
  if (type == '1001')
    typeStr = 'openProt'
  if (type == '1002')
    typeStr = 'intervlOut'
  if (type == '1003')
    typeStr = 'instControl'
  if (type == '1005')
    typeStr = 'closeProt'
  if (type == '1006')
    typeStr = 'get version'
  if (type == '1007')
    typeStr = 'check password type num'
  if (type == '1008')
    typeStr = 'check password type num'
  console.log('[[[[[[[[[[[[[[[[[[[[[[[pwdJsonp asynctemp', this.settings.asynctemp)
  if (this.settings.asynctemp == true) {
	  jsonp({
      url: urls,
      time: timenums,
      data: { str: JSON.stringify(RZCIJSON), jsoncallback: 'cb', type: typeStr },
      callback: 'jsoncallback',
      success(x) {
	  // datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
	  // try {
        // Ajax.request({
		  // url: urls,
		  // timeout: 2000,
		  // type: 'GET',
		  // async: false,
		  // data: {
        // jsoncallback: 'jsoncallback',
        // str: datas,
        // type: typeStr,
		  // },
		  // success(x) {
        // x = x.responseText
        // x = x.substring(13, x.length - 1)
        // x = JSON.parse(x)
        if (type == '1000') {
			  objVersion = x.data

			  const vers = objVersion.split('  ')
			  if (vers[1] == 1) {
            if (plats == 1) {
				  license = licenseUOSAMD
				  PGEdit_Edge_VERSION = PGEdit_UOSamd_VERSION
            }
            else if (plats == 2) {
				  license = licenseUOSMIPS
				  PGEdit_Edge_VERSION = PGEdit_UOSmips_VERSION
            }
            else if (plats == 3) {
				  license = licenseUOSARM
				  PGEdit_Edge_VERSION = PGEdit_UOSarm_VERSION
            }
            else if (plats == 4) {
				  license = licenseUOSSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 2) {
            if (plats == 1) {
				  license = licenseKYAMD
				  PGEdit_Edge_VERSION = PGEdit_KYamd_VERSION
            }
            else if (plats == 2) {
				  license = licenseKYMIPS
				  PGEdit_Edge_VERSION = PGEdit_KYmips_VERSION
            }
            else if (plats == 3) {
				  license = licenseKYARM
				  PGEdit_Edge_VERSION = PGEdit_KYarm_VERSION
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 3) {
            if (plats == 1) {
				  license = licenseNKYAMD
            }
            else if (plats == 2) {
				  license = licenseNKYMIPS
            }
            else if (plats == 3) {
				  license = licenseNKYARM
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }
			  else if (vers[1] == 4) {
            if (plats == 1) {
				  license = licenseNKYAMD
            }
            else if (plats == 2) {
				  license = licenseNKYMIPS
            }
            else if (plats == 3) {
				  license = licenseNKYARM
            }
            else if (plats == 4) {
				  license = licenseKYSW
				  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
            }
			  }

			  if (x.code == 0) {
            if (logFlag)
				  console.log('control is installed')
			  }
			  else {
            if (logFlag)
				  console.log(`code:${x.code}`)
			  }
			  if (callf)
            callf(obj)
        }
        else if (type == '1001') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('openProt success')
            }
            inFlag[id].flag = true
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1002') {
			  const code = parseInt(x.data)
			  if (logFlag) {
            console.log(`pgeWindowsID:${id}`)
            console.log(`x.data.length:${x.data},x.code:${x.code}`)
			  }
			  const va = pgeCtrl.pwdGetEById(inputID); const len = va.value.len; let y = ''; let i = 0
			  for (; i < code; i++) y += '*'
			  va.value = y
        }
        else if (type == '1003') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('inst success')
            }
            obj.initControl(id, '', callf, callf2)
			  }
			  else {
            const tempobj = pgeCtrl.pwdGetEById(inputID)

            if (tempobj)
				  tempobj.parentNode.innerHTML = `err,inst code:${x.code}`
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1004') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('init success')
            }
            inFlag[id] = { flag: false }
            if (callf)
				  callf(obj)
            if (window.isC2 == false)
				  if (callf2) { callf2(obj); window.isC2 = true }
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
        }
        else if (type == '1005') {
			  if (x.code == 0) {
            if (logFlag) {
				  console.log(`pgeWindowsID:${id}`)
				  console.log('closeProt success')
            }
            inFlag[id].flag = false
			  }
			  if (logFlag)
            console.log(`x.data:${x.data},x.code:${x.code}`)
			  inFlag[id].id = false
        }
        else if (type == '1006') {
			  if (callf)
            callf(x.data)
        }
        else if (type == '1007') {
			  if (callf)
            callf(x.data)
        }
        else if (type == '1008') {
			  if (callf)
            callf(x.data)
        }
		  },
		  // error(x) {
      // d = -1
			   // if (type == '1000') {
				   // if (port < lastPort) {
      // port++
      // obj.checkInstall(1, callf)
				   // }
			  // else {
      // if (callf)
				  // callf(false)
			  // }
			   // }
		  // },
      // })
	  // }
	  // catch (err) {
		   // if (type == '1000') {
			   // if (port < lastPort) {
      // port++
      // obj.checkInstall(1, callf)
			   // }
		  // else {
      // if (callf)
			  // callf(false)
		  // }
		   // }
	  // }
      fail(jqXHR, textStatus, errorThrown) {
        if (type == '1000') {
          if (port < lastPort) {
            port++
            obj.checkInstall(1, callf)
          }
          else { // checkInstall = false;

          }
        }
      },
	  })
  }
  else {
    datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
		  try {
      Ajax.request({
			  url: urls,
			  timeout: 2000,
			  type: 'GET',
			  async: false,
			  data: {
          jsoncallback: 'jsoncallback',
          str: datas,
          type: typeStr,
			  },
			  success(x) {
          x = x.responseText
          x = x.substring(13, x.length - 1)
          x = JSON.parse(x)
          if (type == '1000') {
				  objVersion = x.data

				  const vers = objVersion.split('  ')
				  if (vers[1] == 1) {
              if (plats == 1) {
					  license = licenseUOSAMD
					  PGEdit_Edge_VERSION = PGEdit_UOSamd_VERSION
              }
              else if (plats == 2) {
					  license = licenseUOSMIPS
					  PGEdit_Edge_VERSION = PGEdit_UOSmips_VERSION
              }
              else if (plats == 3) {
					  license = licenseUOSARM
					  PGEdit_Edge_VERSION = PGEdit_UOSarm_VERSION
              }
              else if (plats == 4) {
					  license = licenseUOSSW
					  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
				  }
				  else if (vers[1] == 2) {
              if (plats == 1) {
					  license = licenseKYAMD
					  PGEdit_Edge_VERSION = PGEdit_KYamd_VERSION
              }
              else if (plats == 2) {
					  license = licenseKYMIPS
					  PGEdit_Edge_VERSION = PGEdit_KYmips_VERSION
              }
              else if (plats == 3) {
					  license = licenseKYARM
					  PGEdit_Edge_VERSION = PGEdit_KYarm_VERSION
              }
              else if (plats == 4) {
					  license = licenseKYSW
					  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
				  }
				  else if (vers[1] == 3) {
              if (plats == 1) {
					  license = licenseNKYAMD
              }
              else if (plats == 2) {
					  license = licenseNKYMIPS
              }
              else if (plats == 3) {
					  license = licenseNKYARM
              }
              else if (plats == 4) {
					  license = licenseKYSW
					  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
				  }
				  else if (vers[1] == 4) {
              if (plats == 1) {
					  license = licenseNKYAMD
              }
              else if (plats == 2) {
					  license = licenseNKYMIPS
              }
              else if (plats == 3) {
					  license = licenseNKYARM
              }
              else if (plats == 4) {
					  license = licenseKYSW
					  PGEdit_Edge_VERSION = PGEdit_Linuxsw_VERSION
              }
				  }

				  if (x.code == 0) {
              if (logFlag)
					  console.log('control is installed')
				  }
				  else {
              if (logFlag)
					  console.log(`code:${x.code}`)
				  }
				  if (callf)
              callf(obj)
          }
          else if (type == '1001') {
				  if (x.code == 0) {
              if (logFlag) {
					  console.log(`pgeWindowsID:${id}`)
					  console.log('openProt success')
              }
              inFlag[id].flag = true
				  }
				  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1002') {
				  const code = parseInt(x.data)
				  if (logFlag) {
              console.log(`pgeWindowsID:${id}`)
              console.log(`x.data.length:${x.data},x.code:${x.code}`)
				  }
				  const va = pgeCtrl.pwdGetEById(inputID); const len = va.value.len; let y = ''; let i = 0
				  for (; i < code; i++) y += '*'
				  va.value = y
          }
          else if (type == '1003') {
				  if (x.code == 0) {
              if (logFlag) {
					  console.log(`pgeWindowsID:${id}`)
					  console.log('inst success')
              }
              obj.initControl(id, '', callf, callf2)
				  }
				  else {
              const tempobj = pgeCtrl.pwdGetEById(inputID)

              if (tempobj)
					  tempobj.parentNode.innerHTML = `err,inst code:${x.code}`
				  }
				  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1004') {
				  if (x.code == 0) {
              if (logFlag) {
					  console.log(`pgeWindowsID:${id}`)
					  console.log('init success')
              }
              inFlag[id] = { flag: false }
              if (callf)
					  callf(obj)
              if (window.isC2 == false)
					  if (callf2) { callf2(obj); window.isC2 = true }
				  }
				  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
          }
          else if (type == '1005') {
				  if (x.code == 0) {
              if (logFlag) {
					  console.log(`pgeWindowsID:${id}`)
					  console.log('closeProt success')
              }
              inFlag[id].flag = false
				  }
				  if (logFlag)
              console.log(`x.data:${x.data},x.code:${x.code}`)
				  inFlag[id].id = false
          }
          else if (type == '1006') {
				  if (callf)
              callf(x.data)
          }
          else if (type == '1007') {
				  if (callf)
              callf(x.data)
          }
          else if (type == '1008') {
				  if (callf)
              callf(x.data)
          }
			  },
			  error(x) {
          d = -1
				   if (type == '1000') {
					   if (port < lastPort) {
              port++
              obj.checkInstall(1, callf)
					   }
				  else {
              if (callf)
					  callf(false)
				  }
				   }
			  },
      })
		  }
		  catch (err) {
			   if (type == '1000') {
				   if (port < lastPort) {
          port++
          obj.checkInstall(1, callf)
				   }
			  else {
          if (callf)
				  callf(false)
			  }
			   }
		  }
		  // 	fail: function (jqXHR, textStatus, errorThrown) {
		  // 		if (type == "1000") {
		  // 			if (port < lastPort) {
		  // 				port++;
		  // 				obj.checkInstall(1, callf);

		  // 			} else {//checkInstall = false;
		  // 				return;
		  // 			}
		  // 		}
		  // 	}
		  // })
  }
}
// 转换版本号
// 将控件版本号转换成整形值，用于比较
pge.prototype.getConvertVersion = function (version) {
  try {
    if (version == undefined || version == '') {
      return 0
    }
    else {
      let flag = false; m = ''
      if (this.osBrowser == 1 || this.osBrowser == 3) {
        if (version.includes(','))
          flag = true
      }

      if (flag)
        m = version.split(',')
      else m = version.split('.')
      const v = parseInt(m[0] * 1000) + parseInt(m[1] * 100) + parseInt(m[2] * 10) + parseInt(m[3])
      return v
    }
  }
  catch (err) { return 0 }
}
// 毫秒，主要用于防止缓存
pge.prototype.pwdGetTime = function () {
  return new Date().getTime()
}
// 字符串两端去空格
pge.prototype.trim = function (x) {
  return x.replace(/(^\s*)|(\s*$)/g, '')
}
// 通过id获取页面元素
pge.prototype.pwdGetEById = function (id) {
  return document.getElementById(id)
},
pge.prototype.pwdhtml = function (id, htmlstr) {
  this.pwdGetEById(id).innerHTML = htmlstr
}
pge.prototype.pwdObjhtml = function (obj, htmlstr) {
  obj.innerHTML = htmlstr
}
// 加密通信数据
pge.prototype.getEnStr = function (sKey, jsonStr) {
  console.log('pge.prototype.getEnStr sKey is--', sKey)

  const neiKey = [0x11, 0x22, 0x33, 0x44, 0x55, 0x66, 0x77, 0x1A, 0x2A, 0x2B,
    0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B, 0x11, 0x22, 0x33, 0x44, 0x55,
    0x66, 0x77, 0x1A, 0x2A, 0x2B, 0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B]
  let fkey = ''; let lx = ''
  for (let i = 0; i < sKey?.length; i++) {
    lx = String.fromCharCode(sKey[i].charCodeAt(0) ^ neiKey[i])
    fkey += lx
  }
  const hexKey = CryptoJS.enc.Utf8.parse(fkey)
  const enStr = CryptoJS.AES.encrypt(JSON.stringify(jsonStr), hexKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return enStr.toString()
}
function getEnStr(sKey, jsonStr) {
  const neiKey = [0x11, 0x22, 0x33, 0x44, 0x55, 0x66, 0x77, 0x1A, 0x2A, 0x2B,
    0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B, 0x11, 0x22, 0x33, 0x44, 0x55,
    0x66, 0x77, 0x1A, 0x2A, 0x2B, 0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B]
  let fkey = ''; let lx = ''
  for (let i = 0; i < sKey?.length; i++) {
    lx = String.fromCharCode(sKey[i].charCodeAt(0) ^ neiKey[i])
    fkey += lx
  }
  const hexKey = CryptoJS.enc.Utf8.parse(fkey)
  const enStr = CryptoJS.AES.encrypt(JSON.stringify(jsonStr), hexKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return enStr.toString()
}
// 设置升级提示文字
pge.prototype.setDownText = function () {
  if (isInstalled != -1)
    this.pgeDownText = upText
},
// 当按enter键时，提交表单
pge.prototype.setSX = function (e, m, o, windId, pgeId) {
  let keynum; const va = this.pwdGetEById(o.id); var len = va.value.length; const maxlen = this.settings.pgeMaxLength + 1
  if (window.event)
    keynum = e.keyCode
		 else if (e.which)
    keynum = e.which

  if (keynum == 13) {
    o.blur()
    // 执行onkeydown
    if (windId) {
      const temppge = pgePoll[windId]
      if (temppge.settings.pgeOnKeyDown)
        temppge.settings.pgeOnKeyDown()
    }
    // eval("("+m+")");
  }
  else if (keynum == 8) {
    const ctrl = o
    let caretPos = 0
    var len = ctrl.value.length
    if (document.selection) {
      const sel = document.selection.createRange()
      sel.moveStart('character', -ctrl.value.length)
      caretPos = sel.text.length
    }
    else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
      caretPos = ctrl.selectionStart
    }
    // console.log("caretPos" + caretPos);
    const bl = caretPos < (len - 1)
    if ((caretPos == 0 && len != 0) || bl) {
      // console.log("clear");
      if (windId && pgeId)
        this.pwdClear(windId, pgeId)
				 else
        this.pwdClear()
    }
  }
},
// 控制不能从密码框中间编辑
pge.prototype.setCX = function (ctrl, wid) {
  // 执行onfocus
  if (wid) {
    const temppge = pgePoll[wid]
    if (temppge.settings.pgeOnFocus)
      temppge.settings.pgeOnFocus()
  }
  let caretPos = 0; const len = ctrl.value.length
  if (document.selection) {
    const sel = document.selection.createRange()
    sel.moveStart('character', -ctrl.value.length)
    caretPos = sel.text.length
  }
  else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
    caretPos = ctrl.selectionStart
  }
  if (caretPos <= len) {
    if (ctrl.setSelectionRange) { // 设置光标位置函数 FF
      setTimeout(() => {
        ctrl.setSelectionRange(len, len)
      }, 1)
    }
    else if (ctrl.createTextRange) { // ie
      const range = ctrl.createTextRange()
      range.collapse(true)
      range.moveEnd('character', len)
      range.moveStart('character', len)
      range.select()
    }
  }
},
// 实例化密码控件窗口
pge.prototype.instControl = function (id, wid, obj, callf, callf2) {
  ICJSON.id = wid
  this.pwdJsonp(ICJSON, '1003', wid, id, callf, callf2)
}
// 初始化密码控件窗口参数
pge.prototype.initControl = function (id, inputID, callf, callf2) {
  const my = `${this.settings.AffineX}|${this.settings.AffineY}`// SM2公钥
  INCJSON.id = id, INCJSON.data.edittype = this.settings.pgeEditType, INCJSON.data.maxlength = this.settings.pgeMaxLength
  INCJSON.data.reg1 = this.settings.pgeEreg1, INCJSON.data.reg2 = this.settings.pgeEreg2, INCJSON.data.sm2xyhexkey = my
  INCJSON.data.lic = { liccode: license, url: urlPar }
  if (this.osBrowser == 11)
    INCJSON.data.lic.liccode = licenseMac
  this.pwdJsonp(INCJSON, '1004', id, '', callf, callf2)
  // 初始化对应id心跳值
  onceInterv[id] = ''
}
// 开启密码控件保护
pge.prototype.openProt = function (id, inputID) {
  inFlag[id].flag = false, OPJSON.id = id
  this.pwdJsonp(OPJSON, '1001', id)
  if (typeof onceInterv[id] == 'string') { // 监听焦点切出
    for (let i = 0; i < iterArray.length; i++)
      window.clearInterval(iterArray[i])

    onceInterv[id] = window.setInterval(`pgeCtrl.intervlOut("${id}","${inputID}")`, 800)
    iterArray.push(onceInterv[id])
  }
},

// 检测心跳
pge.prototype.intervlOut = function (id, inputID) {
  XTJSON.id = id
  this.pwdJsonp(XTJSON, '1002', id, inputID)
},
// 关闭密码控件保护
pge.prototype.closeProt = function (id, inputID) {
  // 执行onblur
  if (id) {
    const temppge = pgePoll[id]
    if (temppge.settings.pgeOnBlur)
      temppge.settings.pgeOnBlur()
  }
  CPJSON.id = id
  this.pwdJsonp(CPJSON, '1005', id)
  if (typeof onceInterv[id] == 'number') {
    for (let i = 0; i <= iterArray.length; i++)
      window.clearInterval(iterArray[i])

    onceInterv[id] = ''
  }
}
// 同步版ajax
var Ajax = (function () {
  function request(opt) {
    function fn() {
    }
    let url = opt.url || ''
    const async = opt.async !== false; let method = opt.method || 'GET'; let data = opt.data
			|| null; const success = opt.success || fn; const error = opt.failure
				|| fn
    method = method.toUpperCase()
    if (method == 'GET' && data) {
      let args = ''
      if (typeof data == 'string') {
        // alert("string")
        args = data
      }
      else if (typeof data == 'object') {
        // alert("object")
        const arr = []
        for (const k in data) {
          const v = data[k]
          arr.push(`${k}=${v}`)
        }
        args = arr.join('&')
      }
      url += (!url.includes('?') ? '?' : '&') + args
      data = null
    }
    const xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject('Microsoft.XMLHTTP')
    xhr.onreadystatechange = function () {
      _onStateChange(xhr, success, error)
    }
    xhr.open(method, url, async)
    if (method == 'POST') {
      xhr.setRequestHeader('Content-type',
        'application/x-www-form-urlencoded;')
    }
    xhr.send(data)
    return xhr
  }
  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      const s = xhr.status
      if (s >= 200 && s < 300)
        success(xhr)
			 else
        failure(xhr)
    }
    else {
    }
  }
  return {
    request,
  }
}())

// 异步版ajax
function jsonp(options) {
  options = options || {}
  if (!options.url || !options.callback)
    throw new Error('参数不合法')

  const callbackName = (`jsonp_${Math.random()}`).replace('.', '')
  const oHead = document.getElementsByTagName('head')[0]
  options.data[options.callback] = callbackName
  const params = formatParams(options.data)
  const oS = document.createElement('script')
  oHead.appendChild(oS)

  // 创建jsonp回调函数
  window[callbackName] = function (json) {
    oHead.removeChild(oS)
    clearTimeout(oS.timer)
    window[callbackName] = null
    options.success && options.success(json)
  }
  // 发送请求
  oS.src = `${options.url}?${params}`
  // 超时处理
  if (options.time) {
    oS.timer = setTimeout(() => {
      window[callbackName] = null
      oHead.removeChild(oS)
      options.fail && options.fail({ message: '超时' })
    }, options.time)
  }
}
// 格式化参数
function formatParams(data) {
  const arr = []
  for (const name in data)
    arr.push(`${name}=${encodeURIComponent(data[name])}`)

  return arr.join('&')
}
// a.pge = pge;
// a.pges = pges;
// a.PGEdit_Edge_VERSION = PGEdit_Edge_VERSION;
// a.PGEdit_Edge_VERSIONMac = PGEdit_Edge_VERSIONMac;
// a.PGEdit_Update = PGEdit_Update;
// a.inFlag = inFlag;
// })(window);
//  window.pgeCtrl = new pge();
const random = 'FB976FCC1291467AB43E5BF5A178120A'
const datab = 'fj5qLJhRQPEnaYuENG/mYCIqVToP/T98lWdnAqK5Uxs='
let pgeCtrl = new pge({
  pgeRZRandNum: random,
  pgeRZDataB: datab,
})
function sleep(n) {
  const start = new Date().getTime()
  while (true) {
    if (new Date() - start > n)
      break
  }
}

function intervlOut(id, inputID) {
  XTJSON.id = id
  pwdJsonp(XTJSON, '1002', id, inputID)
}

function setCX(ctrl, wid) {
  // 执行onfocus
  if (wid) {
    const temppge = pgePoll[wid]
    if (temppge.settings.pgeOnFocus)
      temppge.settings.pgeOnFocus()
  }
  console.log('ctrl is --', ctrl)
  let caretPos = 0; const len = ctrl.value.length
  if (document.selection) {
    const sel = document.selection.createRange()
    sel.moveStart('character', -ctrl.value.length)
    caretPos = sel.text.length
  }
  else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
    caretPos = ctrl.selectionStart
  }
  if (caretPos <= len) {
    if (ctrl.setSelectionRange) { // 设置光标位置函数 FF
      setTimeout(() => {
        ctrl.setSelectionRange(len, len)
      }, 1)
    }
    else if (ctrl.createTextRange) { // ie
      const range = ctrl.createTextRange()
      range.collapse(true)
      range.moveEnd('character', len)
      range.moveStart('character', len)
      range.select()
    }
  }
}
function pwdClear(windowid, pgeId) {
  const tempo = pwdGetEById(pgeId)
  if (!tempo)
    return

  CLPJSON.id = windowid
  pwdGetData(CLPJSON, '2007')
  tempo.value = ''
}
function pwdGetEById(id) {
  return document.getElementById(id)
}
function pwdGetData(datas, type) {
  const datac = getEnStr(pgeRZRandNum, datas)
  const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
  let d = 0; let typeStr = ''
  if (type == '2000')
    typeStr = 'set random'
  if (type == '2001')
    typeStr = 'get length'
  if (type == '2002')
    typeStr = 'get hash'
  if (type == '2003')
    typeStr = 'get simple'
  if (type == '2004')
    typeStr = 'get pwdnums'
  if (type == '2005')
    typeStr = 'get pwdnumstwo'
  if (type == '2006')
    typeStr = 'pwd valid'
  if (type == '2007')
    typeStr = 'clear pwd'
  if (type == '2008')
    typeStr = 'get pwdresult'
  if (type == '2009')
    typeStr = 'get mac'
  if (type == '2010')
    typeStr = 'get harddisk'
  if (type == '2011')
    typeStr = 'get cpu'
  datas = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')
  Ajax.request({
    url: urls,
    timeout: 2000,
    type: 'GET',
    async: false,
    data: {
      jsoncallback: 'jsoncallback',
      str: datas,
      type: typeStr,
    },
    success(x) {
      x = x.responseText
      x = x.substring(13, x.length - 1)
      x = JSON.parse(x)
      d = x.data
    },
    error(x) {
      d = -1
    },
  })
  return d
}
function setSX(e, m, o, windId, pgeId) {
  let keynum; const va = pwdGetEById(o.id); var len = va.value.length
  if (window.event)
    keynum = e.keyCode
	 else if (e.which)
    keynum = e.which

  if (keynum == 13) {
    o.blur()
    // 执行onkeydown
    if (windId) {
      const temppge = pgePoll[windId]
      if (temppge.settings.pgeOnKeyDown)
        temppge.settings.pgeOnKeyDown()
    }
    // eval("("+m+")");
  }
  else if (keynum == 8) {
    const ctrl = o
    let caretPos = 0
    var len = ctrl.value.length
    if (document.selection) {
      const sel = document.selection.createRange()
      sel.moveStart('character', -ctrl.value.length)
      caretPos = sel.text.length
    }
    else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
      caretPos = ctrl.selectionStart
    }
    // console.log("caretPos" + caretPos);
    const bl = caretPos < (len - 1)
    if ((caretPos == 0 && len != 0) || bl) {
      // console.log("clear");
      if (windId && pgeId)
        pwdClear(windId, pgeId)
			 else
        pwdClear()
    }
  }
}
function closeProt(id, inputID) {
  // 执行onblur
  if (id) {
    const temppge = pgePoll[id]
    if (temppge.settings.pgeOnBlur)
      temppge.settings.pgeOnBlur()
  }
  CPJSON.id = id
  pwdJsonp(CPJSON, '1005', id)
  if (typeof onceInterv[id] == 'number') {
    for (let i = 0; i <= iterArray.length; i++)
      window.clearInterval(iterArray[i])

    onceInterv[id] = ''
  }
}
function openProt(id, inputID) {
  inFlag[id].flag = false, OPJSON.id = id
  pwdJsonp(OPJSON, '1001', id)
  if (typeof onceInterv[id] == 'string') { // 监听焦点切出
    for (let i = 0; i < iterArray.length; i++)
      clearInterval(iterArray[i])

    onceInterv[id] = setInterval(() => {
      intervlOut(id, inputID)
    }, 800)
    iterArray.push(onceInterv[id])
  }
}
function pgeInit(callf, callf2, asynctemp) {
  console.log('[[[[[[[[[[[[[[[[[[[[[[pgeInit asynctemp', asynctemp)
  if (pgeCtrl.osBrowser != 10 && pgeCtrl.osBrowser != 11) {
    for (let i = 0; i < pges.length; i++) {
      pges[i].setLicense()
      pges[i].setIePlaceholder()
    }
    if (callf)
      callf(window.isInstalled)
    if (callf2)
      callf2()
  }
  else {
    pgeCtrl.checkInstall(1, (isIns) => {
      if (callf)
        callf(isIns)
      window.isC2 = false
      if (isIns) {
        let o
        for (var i = 0; i < pges.length; i++) {
          sleep(100)
          const objttp = pges[i]
          var id = objttp.settings.pgeId
          var winId = objttp.settings.pgeWindowID
          let strr = ''
          let tempversion = PGEdit_Edge_VERSION
          if (objttp.osBrowser == 11)
            tempversion = PGEdit_Edge_VERSIONMac

          if (objttp.osBrowser == 10)
            strr = 'this.type=\'text\';'

          if (objttp.getConvertVersion(objVersion) < objttp.getConvertVersion(tempversion) && PGEdit_Update == '1') {
            const winPath = objttp.settings.pgePath + objttp.pgeditFFExe
            const as = document.getElementsByClassName('winA')
            for (var i = 0; i < as.length; i++) {
              as[i].innerHTML = '请点此升级控件'
              as[i].href = winPath
            }
            return
          }
          else {
            try {
              let tempplaceholder = ''
              if (objttp.settings.pgePlaceholder != undefined && objttp.settings.pgePlaceholder != '')
                tempplaceholder = objttp.settings.pgePlaceholder

              document.querySelector(`#${id}_down`).parentNode.innerHTML = `<input type="text"  id = "${id}" style="ime-mode:disabled"  placeholder="${tempplaceholder}"  tabindex="${objttp.settings.pgeTabIndex}" autocomplete="off" class="${objttp.settings.pgeClass}"/>`
              // onfocus="' + strr + 'pgeCtrl.openProt(\'' + winId + '\',this.id);pgeCtrl.setCX(this,\'' + winId + '\');"
              // onclick = "pgeCtrl.setCX(this)"
              // onkeydown="pgeCtrl.setSX(event,0,this,\'' + winId + '\',\'' + id + '\');"
              // onblur = "pgeCtrl.closeProt(\'' + winId + '\',this.id);"
            }
            catch (err) {
              // continue;
            }
          }
          objttp.instControl(id, winId, objttp, (obj) => {
            id = obj.settings.pgeId
            winId = obj.settings.pgeWindowID
            o = obj.pwdGetEById(id)
            if (!o)
              return

            o.pid = winId
            o.id = id

            o.openProt = openProt
            if (obj.osBrowser == 10 || obj.osBrowser == 11) {
              if (o != null) {
                o.onfocus = function (e) {
                  openProt(this.pid, this.id)
                  setCX(this, this.pid)
                }
                o.onclick = function (e) {
                  setCX(this)
                }
                o.onkeydown = function (e) {
                  setSX(e, 0, this, this.pid, this.id)
                }
                o.onblur = function (e) {
                  closeProt(this.pid, this.id)
                }
                if (obj.osBrowser == 11 || isLinux) {
                  o.onkeypress = function (e) {
                    let objtemp
                    for (const xo in pges) {
                      if (pges[xo].settings.pgeId == this.id)
                        objtemp = pges[xo]
                    }
                    let chrTyped; var chrCode = 0; const evt = e || event; var chrCode = evt.which
                    const x = String.fromCharCode(chrCode)
                    const maxlength = parseInt(objtemp.settings.pgeMaxLength)
                    if (chrCode >= 32 && chrCode <= 126) {
                      if (this.value.length > (maxlength - 1))
                        return false
                      let reg1 = objtemp.settings.pgeEreg1.replace('*', '')
                      reg1 = new RegExp(reg1)
                      if (reg1.test(x))
                        this.value += '*'
                      return false
                    }
                    else { return true }
                  }
                  o.onkeydown = function (e) {
                    let chrTyped; let chrCode = 0; const evt = e || event
                    chrCode = evt.which
                    const x = String.fromCharCode(chrCode)
                    if (chrCode == 13) {
                      this.blur()
                      eval(`(${obj.settings.pgeOnKeyDown})`)
                    }
                    else if (chrCode >= 37 && chrCode <= 40) {
                      return false
                    }
                    else { return true }
                  }
                }
                if (obj.osBrowser == 10 && !isLinux) {
                  o.onkeypress = function () {
                    return inFlag[this.pid].flag
                  }
                }
              }
            }
          }, callf2)
        }
        pges = []
      }
    }, asynctemp)
  }
}

export { pge, pgeCtrl, pgeInit }
